import {
  ModalBlocker,
  ModalFooter,
  ModalHeader,
  ModalWindow,
  FlexSpacer,
  Panel,
  Button,
} from '@epam/promo';
import { BaseModalProps, MODAL_ACTION } from './BaseModal.model';
import css from './BaseModal.module.scss';

export const BaseModal = ({
  children,
  key,
  isActive,
  zIndex,
  abort,
  success,
  close,
  successAction,
  abortAction,
  title,
  isDisabled = false,
}: BaseModalProps) => (
  <ModalBlocker
    key={key}
    disableCloseByEsc
    disallowClickOutside
    abort={abort}
    isActive={isActive}
    rawProps={{ 'data-testid': 'modal-window' }}
    success={success}
    zIndex={zIndex}>
    <ModalWindow width="600">
      <Panel background="white">
        <ModalHeader cx={css.modal__header} title={title} onClose={close} />
        {children}
        <ModalFooter cx={css.modal__footer}>
          <FlexSpacer />
          <Button
            caption={abortAction}
            color={successAction === MODAL_ACTION.SAVE ? 'red' : 'gray'}
            cx={
              css[
                `modal__btn-cancel ${
                  successAction === MODAL_ACTION.SAVE && 'modal__btn-save'
                }`
              ]
            }
            fill="white"
            onClick={() => abort()}
          />
          <Button
            caption={successAction}
            color={successAction === MODAL_ACTION.DELETE ? 'red' : 'green'}
            isDisabled={isDisabled}
            onClick={() => success('Success action')}
          />
        </ModalFooter>
      </Panel>
    </ModalWindow>
  </ModalBlocker>
);
